export const COUNTRIES = [
  { value: 'Andorra', label: 'Andorra' },
  { value: 'United Arab Emirates', label: 'United Arab Emirates' },
  { value: 'Afghanistan', label: 'Afghanistan' },
  { value: 'Antigua and Barbuda', label: 'Antigua and Barbuda' },
  { value: 'Anguilla', label: 'Anguilla' },
  { value: 'Albania', label: 'Albania' },
  { value: 'Armenia', label: 'Armenia' },
  { value: 'Angola', label: 'Angola' },
  { value: 'Antarctica', label: 'Antarctica' },
  { value: 'Argentina', label: 'Argentina' },
  { value: 'American Samoa', label: 'American Samoa' },
  { value: 'Austria', label: 'Austria' },
  { value: 'Australia', label: 'Australia' },
  { value: 'Aruba', label: 'Aruba' },
  { value: 'Åland Islands', label: 'Åland Islands' },
  { value: 'Azerbaijan', label: 'Azerbaijan' },
  { value: 'Bosnia and Herzegovina', label: 'Bosnia and Herzegovina' },
  { value: 'Barbados', label: 'Barbados' },
  { value: 'Bangladesh', label: 'Bangladesh' },
  { value: 'Belgium', label: 'Belgium' },
  { value: 'Burkina Faso', label: 'Burkina Faso' },
  { value: 'Bulgaria', label: 'Bulgaria' },
  { value: 'Bahrain', label: 'Bahrain' },
  { value: 'Burundi', label: 'Burundi' },
  { value: 'Benin', label: 'Benin' },
  { value: 'Saint Barthélemy', label: 'Saint Barthélemy' },
  { value: 'Bermuda', label: 'Bermuda' },
  { value: 'Brunei Darussalam', label: 'Brunei Darussalam' },
  { value: 'Bolivia', label: 'Bolivia' },
  { value: 'Brazil', label: 'Brazil' },
  { value: 'Bahamas', label: 'Bahamas' },
  { value: 'Bhutan', label: 'Bhutan' },
  { value: 'Bouvet Island', label: 'Bouvet Island' },
  { value: 'Botswana', label: 'Botswana' },
  { value: 'Belarus', label: 'Belarus' },
  { value: 'Belize', label: 'Belize' },
  { value: 'Canada', label: 'Canada' },
  { value: 'Cong', label: 'Congo' },
  { value: 'Central African Republic', label: 'Central African Republic' },
  { value: 'Congo', label: 'Congo' },
  { value: 'Switzerland', label: 'Switzerland' },
  { value: 'Côte d\'Ivoire', label: 'Côte d\'Ivoire' },
  { value: 'Cook Islands', label: 'Cook Islands' },
  { value: 'Chile', label: 'Chile' },
  { value: 'Cameroon', label: 'Cameroon' },
  { value: 'China', label: 'China' },
  { value: 'Colombia', label: 'Colombia' },
  { value: 'Costa Rica', label: 'Costa Rica' },
  { value: 'Cuba', label: 'Cuba' },
  { value: 'Cabo Verde', label: 'Cabo Verde' },
  { value: 'Curaçao', label: 'Curaçao' },
  { value: 'Christmas Island', label: 'Christmas Island' },
  { value: 'Cyprus', label: 'Cyprus' },
  { value: 'Czechia', label: 'Czechia' },
  { value: 'Germany', label: 'Germany' },
  { value: 'Djibouti', label: 'Djibouti' },
  { value: 'Denmark', label: 'Denmark' },
  { value: 'Dominica', label: 'Dominica' },
  { value: 'Dominican Republic', label: 'Dominican Republic' },
  { value: 'Algeria', label: 'Algeria' },
  { value: 'Ecuador', label: 'Ecuador' },
  { value: 'Estonia', label: 'Estonia' },
  { value: 'Egypt', label: 'Egypt' },
  { value: 'Eritrea', label: 'Eritrea' },
  { value: 'Spain', label: 'Spain' },
  { value: 'Ethiopia', label: 'Ethiopia' },
  { value: 'Finland', label: 'Finland' },
  { value: 'Fiji', label: 'Fiji' },
  { value: 'Faroe Islands', label: 'Faroe Islands' },
  { value: 'France', label: 'France' },
  { value: 'Gabon', label: 'Gabon' },
  { value: 'Great Britain', label: 'Great Britain' },
  { value: 'Grenada', label: 'Grenada' },
  { value: 'Georgia', label: 'Georgia' },
  { value: 'French Guiana', label: 'French Guiana' },
  { value: 'Guernsey', label: 'Guernsey' },
  { value: 'Ghana', label: 'Ghana' },
  { value: 'Gibraltar', label: 'Gibraltar' },
  { value: 'Greenland', label: 'Greenland' },
  { value: 'Gambia', label: 'Gambia' },
  { value: 'Guinea', label: 'Guinea' },
  { value: 'Guadeloupe', label: 'Guadeloupe' },
  { value: 'Equatorial Guinea', label: 'Equatorial Guinea' },
  { value: 'Greece', label: 'Greece' },
  { value: 'Guatemala', label: 'Guatemala' },
  { value: 'Guam', label: 'Guam' },
  { value: 'Guinea-Bissau', label: 'Guinea-Bissau' },
  { value: 'Guyana', label: 'Guyana' },
  { value: 'Honduras', label: 'Honduras' },
  { value: 'Croatia', label: 'Croatia' },
  { value: 'Haiti', label: 'Haiti' },
  { value: 'Hungary', label: 'Hungary' },
  { value: 'Indonesia', label: 'Indonesia' },
  { value: 'Ireland', label: 'Ireland' },
  { value: 'Israel', label: 'Israel' },
  { value: 'India', label: 'India' },
  { value: 'Iraq', label: 'Iraq' },
  { value: 'Iran', label: 'Iran' },
  { value: 'Iceland', label: 'Iceland' },
  { value: 'Italy', label: 'Italy' },
  { value: 'Jersey', label: 'Jersey' },
  { value: 'Jamaica', label: 'Jamaica' },
  { value: 'Jordan', label: 'Jordan' },
  { value: 'Japan', label: 'Japan' },
  { value: 'Kenya', label: 'Kenya' },
  { value: 'Kyrgyzstan', label: 'Kyrgyzstan' },
  { value: 'Cambodia', label: 'Cambodia' },
  { value: 'Kiribati', label: 'Kiribati' },
  { value: 'Comoros', label: 'Comoros' },
  { value: 'North Korea', label: 'North Korea' },
  { value: 'South Korea', label: 'South Korea' },
  { value: 'Kuwait', label: 'Kuwait' },
  { value: 'Kazakhstan', label: 'Kazakhstan' },
  { value: 'Lebanon', label: 'Lebanon' },
  { value: 'Liechtenstein', label: 'Liechtenstein' },
  { value: 'Sri Lanka', label: 'Sri Lanka' },
  { value: 'Liberia', label: 'Liberia' },
  { value: 'Lesotho', label: 'Lesotho' },
  { value: 'Lithuania', label: 'Lithuania' },
  { value: 'Luxembourg', label: 'Luxembourg' },
  { value: 'Latvia', label: 'Latvia' },
  { value: 'Libya', label: 'Libya' },
  { value: 'Morocco', label: 'Morocco' },
  { value: 'Monaco', label: 'Monaco' },
  { value: 'Moldova', label: 'Moldova' },
  { value: 'Montenegro', label: 'Montenegro' },
  { value: 'Madagascar', label: 'Madagascar' },
  { value: 'North Macedonia', label: 'North Macedonia' },
  { value: 'Mali', label: 'Mali' },
  { value: 'Myanmar', label: 'Myanmar' },
  { value: 'Mongolia', label: 'Mongolia' },
  { value: 'Macao', label: 'Macao' },
  { value: 'Martinique', label: 'Martinique' },
  { value: 'Mauritania', label: 'Mauritania' },
  { value: 'Montserrat', label: 'Montserrat' },
  { value: 'Malta', label: 'Malta' },
  { value: 'Mauritius', label: 'Mauritius' },
  { value: 'Maldives', label: 'Maldives' },
  { value: 'Malawi', label: 'Malawi' },
  { value: 'Mexico', label: 'Mexico' },
  { value: 'Malaysia', label: 'Malaysia' },
  { value: 'Mozambique', label: 'Mozambique' },
  { value: 'Namibia', label: 'Namibia' },
  { value: 'New Caledonia', label: 'New Caledonia' },
  { value: 'Niger', label: 'Niger' },
  { value: 'Norfolk Island', label: 'Norfolk Island' },
  { value: 'Nigeria', label: 'Nigeria' },
  { value: 'Nicaragua', label: 'Nicaragua' },
  { value: 'Netherlands', label: 'Netherlands' },
  { value: 'Norway', label: 'Norway' },
  { value: 'Nepal', label: 'Nepal' },
  { value: 'Nauru', label: 'Nauru' },
  { value: 'Niue', label: 'Niue' },
  { value: 'New Zealand', label: 'New Zealand' },
  { value: 'Oman', label: 'Oman' },
  { value: 'Panama', label: 'Panama' },
  { value: 'Peru', label: 'Peru' },
  { value: 'French Polynesia', label: 'French Polynesia' },
  { value: 'Papua New Guinea', label: 'Papua New Guinea' },
  { value: 'Philippines', label: 'Philippines' },
  { value: 'Pakistan', label: 'Pakistan' },
  { value: 'Poland', label: 'Poland' },
  { value: 'Puerto Rico', label: 'Puerto Rico' },
  { value: 'Palestine', label: 'Palestine' },
  { value: 'Portugal', label: 'Portugal' },
  { value: 'Palau', label: 'Palau' },
  { value: 'Paraguay', label: 'Paraguay' },
  { value: 'Qatar', label: 'Qatar' },
  { value: 'Réunion', label: 'Réunion' },
  { value: 'Romania', label: 'Romania' },
  { value: 'Serbia', label: 'Serbia' },
  { value: 'Russia', label: 'Russia' },
  { value: 'Rwanda', label: 'Rwanda' },
  { value: 'Saudi Arabia', label: 'Saudi Arabia' },
  { value: 'Solomon Islands', label: 'Solomon Islands' },
  { value: 'Seychelles', label: 'Seychelles' },
  { value: 'Sudan', label: 'Sudan' },
  { value: 'Sverige', label: 'Sverige' },
  { value: 'Singapore', label: 'Singapore' },
  { value: 'Slovenia', label: 'Slovenia' },
  { value: 'Slovakia', label: 'Slovakia' },
  { value: 'Sierra Leone', label: 'Sierra Leone' },
  { value: 'San Marino', label: 'San Marino' },
  { value: 'Senegal', label: 'Senegal' },
  { value: 'Somalia', label: 'Somalia' },
  { value: 'Suriname', label: 'Suriname' },
  { value: 'South Sudan', label: 'South Sudan' },
  { value: 'El Salvador', label: 'El Salvador' },
  { value: 'Syria', label: 'Syrian' },
  { value: 'Eswatini', label: 'Eswatini' },
  { value: 'Chad', label: 'Chad' },
  { value: 'Togo', label: 'Togo' },
  { value: 'Thailand', label: 'Thailand' },
  { value: 'Tajikistan', label: 'Tajikistan' },
  { value: 'Tokelau', label: 'Tokelau' },
  { value: 'Timor-Leste', label: 'Timor-Leste' },
  { value: 'Turkmenistan', label: 'Turkmenistan' },
  { value: 'Tunisia', label: 'Tunisia' },
  { value: 'Tonga', label: 'Tonga' },
  { value: 'Turkey', label: 'Turkey' },
  { value: 'Trinidad and Tobago', label: 'Trinidad and Tobago' },
  { value: 'Tuvalu', label: 'Tuvalu' },
  { value: 'Taiwan', label: 'Taiwan' },
  { value: 'Tanzania', label: 'Tanzania' },
  { value: 'Ukraine', label: 'Ukraine' },
  { value: 'Uganda', label: 'Uganda' },
  { value: 'USA', label: 'United States of America' },
  { value: 'Uruguay', label: 'Uruguay' },
  { value: 'Uzbekistan', label: 'Uzbekistan' },
  { value: 'Venezuela', label: 'Venezuela' },
  { value: 'Viet Nam', label: 'Viet Nam' },
  { value: 'Vanuatu', label: 'Vanuatu' },
  { value: 'Samoa', label: 'Samoa' },
  { value: 'Yemen', label: 'Yemen' },
  { value: 'Mayotte', label: 'Mayotte' },
  { value: 'South Africa', label: 'South Africa' },
  { value: 'Zambia', label: 'Zambia' },
  { value: 'Zimbabwe', label: 'Zimbabwe' },
];

// FIXME 'Sverige' instead of 'Sweden'